module.exports = __webpack_public_path__ + "static/thumbnail_03_sprite.864e8f74.png";